module.exports = ".nav-wrapper {\n  margin-top: 1rem;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/add-customer/add-customer.component.css
// module id = ./src/app/components/add-customer/add-customer.component.css
// module chunks = main